<h2 mat-dialog-title>Subscribe to our Newsletter</h2>

<form mat-dialog-content [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="outline">
    <mat-label>Email Address</mat-label>
    <input matInput formControlName="email" />
  </mat-form-field>

  <button style="display: none" type="submit"></button>

  <mat-checkbox formControlName="consent" required>I'm happy to be contacted by RealWear</mat-checkbox>
</form>

<mat-dialog-actions>
  <realwear-cloud-marketplace-button
    [disabled]="formGroup.disabled || formGroup.invalid"
    [icon]="faPaperPlane"
    color="green"
    value="Subscribe"
    (click)="onSubmit()"></realwear-cloud-marketplace-button>
</mat-dialog-actions>
